import RenderScriptsContent from "components/RenderScripts/RenderScriptsContent";

const TrueFramePlugin = ({
    vin,
    trueFrameScript,
    trueFrameType,
}: {
  vin: string;
  trueFrameScript: string;
  trueFrameType: string;
}) => {
    return (
        <>
            {trueFrameScript &&
                <RenderScriptsContent
                    scriptContent={trueFrameScript}
                    scriptPosition="scriptOnHead"
                    scriptNameKey="trueframe-script-loader"
                />
            }
            <div className="row">
                <div className="col-md-12 trueframe-feature">
                    <div data-tf-vin={vin} data-tf-type={trueFrameType}></div>
                </div>
            </div>
        </>
    );
};

export default TrueFramePlugin;
